import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Grid from "@mui/material/Unstable_Grid2";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import CancelIcon from "@mui/icons-material/Cancel";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import PostAddIcon from "@mui/icons-material/PostAdd";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Link,
  Tooltip,
  Typography,
} from "@mui/material";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import DatePicker from "../../../../../Supporting files/DatePicker/DatePicker";
import Attachment from "../../../../../Components/Broker/Attachment/Attachment";
import EmailComponent from "../../../../../Components/Broker/EmailComponent/EmailComponent";
import NotesSection from "../../../../../Components/Broker/NotesSection/NotesSection";
import PostQueryForm from "../../../../../Components/Common/PostQuerySP/PostQueryForm";
import BulkUploadForm from "../../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import SlidingPanel from "react-sliding-side-panel";
import AddCdBalance from "../../../../../Components/Broker/AddCdBalance/AddCdBalance";
import TasksSection from "../../../../../Components/Broker/TasksSection/TasksSection";
import FeaturesAndExclusion from "../../../../../Components/Broker/FeaturesAndExclusion/FeaturesAndExclusion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MultipleSearchDropdown from "../../../../../Supporting files/MultipleSearchDropdown/MultipleSearchDropdown";
import RemovePopup from "../../../../../Components/Common/CarForm/RemovePopup/RemovePopup";
import LogsTable from "../../../../../Components/Broker/LogsTable/LogsTable";
import CDLedger from "../../../../../Components/Broker/CDLedger/CDLedger";
import SpocTable from "../../../../../Components/Broker/SPOCTable/SpocTable";
import RKTextFieldDisable from "../../../../../Supporting files/RKTextFieldDisable/RKTextFieldDisable";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdownDisable from "../../../../../Supporting files/SelectDropdownDisable/SelectDropdownDisable";
import SearchDropdownDisable from "../../../../../Supporting files/SearchDropdownDisable/SearchDropdownDisable";
import DatePickerDisable from "../../../../../Supporting files/DatePickerDisable/DatePickerDisable";
import DetailPolicyHistory from "../../../../../Components/Broker/DetailPolicyHistory/DetailPolicyHistory";
import PolicyConfig from "../../../Broker/Policies/PolicyDetail/PolicyConfig/PolicyConfig";

function PolicyDetailView() {
  const navigate = useNavigate();
  const [viewTabsStatus, setViewTabsStatus] = React.useState("overview");
  const [subSection, setSubSection] = React.useState("businesscard");
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("personalDetails");
  const [postQueryForm, setPostQueryForm] = React.useState(false);
  const [editShow, setEditShow] = React.useState(false);
  const [insurerName, setInsurerName] = React.useState("Sbi");
  const [cDBalance, setCDBalance] = React.useState("₹ 8,00,000");
  const [salesPerson, setSalesPerson] = React.useState("#US6789-Kartike");
  const [servicingPartner, setServicingPartner] =
    React.useState("#US6789-Udit");
  const [premium, setPremium] = React.useState("₹ 10,00,000");
  const [tpa, setTpa] = React.useState("Tpa1");
  const [organizationName, setOrganizationName] = React.useState("Evervent");
  const [organizationEmail, setOrganizationEmail] = React.useState(
    "evervent@domain.com"
  );
  const [organizationContact, setOrganizationContact] =
    React.useState("9876543210");
  const [locations, setLocations] = React.useState("Chandigarh");
  const [relationManager, setRelationManager] = React.useState("#US6789-Rahul");
  const [officeAddress, setOfficeAddress] = React.useState("Chandigarh");

  const [voluntryCoverage, setVoluntryCoverage] = React.useState(
    "Employees+Dependents"
  );
  const [voluntryPaymentFreq, setVoluntryPaymentFreq] =
    React.useState("Monthly");
  const [voluntryValue, setVoluntryValue] = React.useState("Rupee");
  const [startDate, setStartDate] = React.useState<Date | null>(new Date());
  const [endDate, setEndDate] = React.useState<Date | null>(new Date());
  const [priorityStatus, setPriorityStatus] = React.useState("Pending");
  const [removeStatus, setRemoveStatus] = React.useState(false);
  const [attachment, setAttachment] = React.useState(false);
  const [emailcomp, setEmailComp] = React.useState(false);
  const [planType, setPlanType] = React.useState(0);

  const [cdbalance, setCdBalance] = React.useState("₹ 1,00,000");

  const [cdbalancepercentage, setCdBalancePercentage] = React.useState("10 %");

  const [corporatebufferValue, setCorporateBufferValue] =
    React.useState("₹ 10,00,000");

  const [spocContact, setSpocContact] = React.useState("");
  const [openContactForm, setOpenContactForm] = React.useState(false);
  const [contactName, setContactName] = React.useState("");
  const [contactOrganization, setContactOrganization] = React.useState("");
  const [contactDepartment, setContactDepartment] = React.useState("");
  const [jobTitle, setJobTitle] = React.useState("");
  const [contactEmail, setContactEmail] = React.useState("");
  const [contactMobile, setContactMobile] = React.useState("");
  const [contactNumber, setContactNumber] = React.useState("");
  const [currentEmployer, setCurrentEmployer] = React.useState("");
  const [sumInsuredThree, setSumInsuredThree] = React.useState("");
  const [uploadFile, setUploadFile] = React.useState(false);
  const [removeCategory, setRemoveCategory] = React.useState(false);
  const [toggle, setToggle] = React.useState(true);
  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const [gradedSectionData, setGradedSectionDta] = useState(0);
  const [voluntaryGradedSectionData, setVoluntaryGradedSectionData] =
    useState(0);
  const [ageTableDetails, setAgeTableDetails] = useState(0);
  const [relatioshipLiveDetails, setRelatioshipLiveDetails] = useState(0);
  // for scrolling
  const policyDetails = useRef(null);
  const insurerDetails = useRef(null);
  const organizationDetails = useRef(null);
  const servicingDetails = useRef(null);
  const attatchmentsdetails = useRef(null);
  const emaildetails = useRef(null);
  const taskdetails = useRef(null);

  const scrollToSection = (elementRef: any) => {
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  // function toggleShowhealth() {
  //   setShowhealth(!showhealth);
  // }

  const prioritystatusData = [
    { key: "Pending", value: "Pending" },
    { key: "Expired", value: "Expired" },
    { key: "Active", value: "Active" },
    { key: "Rejected", value: "Rejected" },
    { key: "Inprogress", value: "Inprogress" },
  ];
  const contact_organization_data = [
    { key: "Evervent", value: "Evervent" },
    { key: "Amazon", value: "Amazon" },
    { key: "Infosys", value: "Infosys" },
    { key: "Google", value: "Google" },
    { key: "Microsoft", value: "Microsoft" },
  ];

  //   const locations_data = [
  //   { label: "Chandigarh", value: "Chandigarh" },
  //   { label: "Dehradun", value: "Dehradun" },
  //   { label: "Delhi", value: "Delhi" },
  //   { label: "Gurugram", value: "Gurugram" },
  //   { label: "Noida", value: "Noida" },
  // ];
  const locations_data = [
    { key: "Chandigarh", year: "Chandigarh" },
    { key: "Dehradun", year: "Dehradun" },
    { key: "Noida", year: "Noida" },
  ];
  const spoc_contact_data = [
    { key: "EV0065VikasSaini", value: "EV0065 Vikas Saini" },
    { key: "EV0016KartikeKakkar", value: "EV0016 Kartike Kakkar" },
  ];
  const contact_department_data = [
    { key: "Engineering", value: "Engineering" },
    { key: "IT", value: "IT" },
    { key: "Human Resource", value: "Human Resource" },
    { key: "Business Development", value: "Business Development" },
    { key: "Designing", value: "Designing" },
    { key: "Management", value: "Management" },
  ];
  const current_employer_data = [
    { key: "Evervent", value: "Evervent" },
    { key: "Amazon", value: "Amazon" },
    { key: "Infosys", value: "Infosys" },
    { key: "Google", value: "Google" },
    { key: "Microsoft", value: "Microsoft" },
  ];
  const job_title_data = [
    {
      key: "Associate Frontend Developer",
      value: "Associate Frontend Developer",
    },
    { key: "Hr", value: "Hr" },
    { Key: "QA Engineer", value: "QA Engineer" },
  ];
  const voluntrycoverage_data = [
    { key: "Employees+Dependents", value: "Employees + Dependents" },
    { key: "Employees+Dependents", value: "Employees + Dependents" },
    { key: "Employees+Dependents", value: "Employees + Dependents" },
    { key: "Employees+Dependents", value: "Employees + Dependents" },
  ];
  const voluntrypaymentfreq_data = [
    { key: "Monthly", value: "Monthly" },
    { key: "Quarterly", value: "Quarterly" },
    { key: "Yearly", value: "Yearly" },
  ];
  const voluntryvalue_data = [
    { key: "Rupee", value: "Rupee" },
    { key: "U.S. Dollar", value: "U.S. Dollar" },
    { key: "Canadian Dollar", value: "Canadian Dollar" },
  ];

  const sumInsuredThree_data = [
    { key: "The Shawshank Redemption", year: 1994 },
    { key: "The Godfather", year: 1972 },
    { key: "The Godfather: Part II", year: 1974 },
    { key: "The Dark Knight", year: 2008 },
    { key: "12 Angry Men", year: 1957 },
    { key: "Schindler's List", year: 1993 },
    { key: "Pulp Fiction", year: 1994 },
  ];

  const relationmanager_data = [
    { label: "CL0001 Rahul", value: "CL0001 Rahul" },
    { label: "CL0002 Kartike", value: "CL0002 Kartike" },
    { label: "CL0003 Vikas", value: "CL0003 Vikas" },
    { label: "CL0004 Umesh", value: "CL0004 Umesh" },
    { label: "CL0005 Rohit", value: "CL0005 Rohit" },
    { label: "CL0006 Varun", value: "CL0006 Varun" },
  ];
  const salesperson_data = [
    { label: "SP5621 Rahul", value: "SP5621 Rahul" },
    { label: "SP5622 Kartike", value: "SP5622 Kartike" },
    { label: "SP5623 Vikas", value: "SP5623 Vikas" },
    { label: "SP5624 Umesh", value: "SP5624 Umesh" },
    { label: "SP5625 Rohit", value: "SP5625 Rohit" },
    { label: "SP5626 Varun", value: "SP5626 Varun" },
  ];
  const servecingpartner_data = [
    { label: "CL63451 Rahul", value: "CL63451 Rahul" },
    { label: "CL63452 Kartike", value: "CL63452 Kartike" },
    { label: "CL63453 Vikas", value: "CL63453 Vikas" },
    { label: "CL63454 Umesh", value: "CL63454 Umesh" },
    { label: "CL63455 Rohit", value: "CL63455 Rohit" },
    { label: "CL63456 Varun", value: "CL63456 Varun" },
  ];
  const tpa_data = [
    { key: "Tpa1", value: "Good Health" },
    { key: "Tpa2", value: "Good Health" },
    { key: "Tpa3", value: "Good Health" },
  ];

  const insurername_data = [
    { key: "Sbi", value: "SBI General Insurance" },
    { key: "Religare", value: "Religare General Insurance" },
    { key: "digit", value: "Digit General Insurance" },
    { key: "reliance", value: "Reliance General Insurance" },
    { key: "MaxBupa", value: "Max Bupa Life Insurance" },
  ];
  const officeAddress_data = [
    { label: "Mohali", value: "Mohali" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Dehradun", value: "Dehradun" },
    { label: "Karnal", value: "Karnal" },
  ];
  const insurers_table = [
    {
      Name: "Rahul Raghuvanshi",
      Organization: "Evervent",
      Mobile: "98784 85562",
      Email: "Vikas.Saini@gmail.com",
      OfficePhone: "987654321",
      OfficeEmail: "Vikas.saini@evervent.in",
      CurrentJob: "Ass. Frontend Developer",
      Department: "Designing",
      CurrentEmployer: "Evervent",
      attatchment: "",
    },
    {
      Name: "Rahul Raghuvanshi",
      Organization: "Evervent",
      Mobile: "98784 85562",
      Email: "Vikas.Saini@gmail.com",
      OfficePhone: "987654321",
      OfficeEmail: "Vikas.saini@evervent.in",
      CurrentJob: "Ass. Frontend Developer",
      Department: "Designing",
      CurrentEmployer: "Evervent",
      attatchment: "",
    },
    {
      Name: "Rahul Raghuvanshi",
      Organization: "Evervent",
      Mobile: "98784 85562",
      Email: "Vikas.Saini@gmail.com",
      OfficePhone: "987654321",
      OfficeEmail: "Vikas.saini@evervent.in",
      CurrentJob: "Ass. Frontend Developer",
      Department: "Designing",
      CurrentEmployer: "Evervent",
      attatchment: "",
    },
    {
      Name: "Rahul Raghuvanshi",
      Organization: "Evervent",
      Mobile: "98784 85562",
      Email: "Vikas.Saini@gmail.com",
      OfficePhone: "987654321",
      OfficeEmail: "Vikas.saini@evervent.in",
      CurrentJob: "Ass. Frontend Developer",
      Department: "Designing",
      CurrentEmployer: "Evervent",
      attatchment: "",
    },
    {
      Name: "Rahul Raghuvanshi",
      Organization: "Evervent",
      Mobile: "98784 85562",
      Email: "Vikas.Saini@gmail.com",
      OfficePhone: "987654321",
      OfficeEmail: "Vikas.saini@evervent.in",
      CurrentJob: "Ass. Frontend Developer",
      Department: "Designing",
      CurrentEmployer: "Evervent",
      attatchment: "",
    },
    {
      Name: "Rahul Raghuvanshi",
      Organization: "Evervent",
      Mobile: "98784 85562",
      Email: "Vikas.Saini@gmail.com",
      OfficePhone: "987654321",
      OfficeEmail: "Vikas.saini@evervent.in",
      CurrentJob: "Ass. Frontend Developer",
      Department: "Designing",
      CurrentEmployer: "Evervent",
      attatchment: "",
    },
    {
      Name: "Rahul Raghuvanshi",
      Organization: "Evervent",
      Mobile: "98784 85562",
      Email: "Vikas.Saini@gmail.com",
      OfficePhone: "987654321",
      OfficeEmail: "Vikas.saini@evervent.in",
      CurrentJob: "Ass. Frontend Developer",
      Department: "Designing",
      CurrentEmployer: "Evervent",
      attatchment: "",
    },
    {
      Name: "Rahul Raghuvanshi",
      Organization: "Evervent",
      Mobile: "98784 85562",
      Email: "Vikas.Saini@gmail.com",
      OfficePhone: "987654321",
      OfficeEmail: "Vikas.saini@evervent.in",
      CurrentJob: "Ass. Frontend Developer",
      Department: "Designing",
      CurrentEmployer: "Evervent",
      attatchment: "",
    },
    {
      Name: "Rahul Raghuvanshi",
      Organization: "Evervent",
      Mobile: "98784 85562",
      Email: "Vikas.Saini@gmail.com",
      OfficePhone: "987654321",
      OfficeEmail: "Vikas.saini@evervent.in",
      CurrentJob: "Ass. Frontend Developer",
      Department: "Designing",
      CurrentEmployer: "Evervent",
      attatchment: "",
    },
  ];
  //******************** */
  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const updateMasterState = (attrName: any, value: any) => {
    if (attrName[0] === "rateData") {
    } else {
      // let data: any = [...rateData];
      // setRateData([...data]);
      if (attrName === "notes_new_data") {
        setNotesData((notesData) => [
          ...notesData,
          { name: "Umesh", date: new Date(), description: value },
        ]);
      } else {
        attrName(value);
      }
    }
  };
  const [ageData, setAgeData] = React.useState([
    [
      { key: "one", value: "10" },
      { key: "two", value: "10" },
      { key: "three", value: "10" },
      { key: "four", value: "10" },
      { key: "five", value: "10" },
      { key: "six", value: "10" },
      { key: "seven", value: "10" },
      { key: "eight", value: "10" },
      { key: "nine", value: "10" },
    ],
  ]);

  return (
    <Box className="layoutWrapper">
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate(-1);
            }}
          >
            <ChevronLeftIcon />
          </Link>
          <span className="detailIcon">Ew</span>
          <div>
            <h3>Evervent #QEOUF7894326</h3>
            <p>Policy No. :34545545646CN0001</p>
          </div>
        </Grid>
        <Grid
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <div>
            <Tooltip title="Remove">
              <Link
                underline="none"
                className="actionLinks red_icon"
                onClick={() => {
                  setRemoveStatus(true);
                }}
              >
                <DeleteOutlineIcon />
              </Link>
            </Tooltip>
          </div>
          <div>
            <Tooltip title="Global Edit">
              <Link className="actionLinks" onClick={() => {}}>
                <BorderColorIcon />
              </Link>
            </Tooltip>
          </div>
          {/* Status Dropdown */}
          <div id={priorityStatus}>
            <div className="status_dropdown" id={priorityStatus}>
              {priorityStatus === "Highest" || priorityStatus === "Active" ? (
                <CheckCircleIcon id={priorityStatus} />
              ) : priorityStatus == "" || priorityStatus === "Rejected" ? (
                <CancelIcon id={priorityStatus} />
              ) : priorityStatus == "Pending" ? (
                <HourglassTopIcon id={priorityStatus} />
              ) : priorityStatus == "Inprogress" ? (
                <PublishedWithChangesIcon id={priorityStatus} />
              ) : priorityStatus == "Expired" ? (
                <HistoryToggleOffIcon id={priorityStatus} />
              ) : null}
              <SelectDropdown
                class_name="inputFieldd"
                title=""
                value={priorityStatus}
                attrName={setPriorityStatus}
                value_update={updateMasterState}
                dropdown_data={prioritystatusData}
                warn_status={false}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "policyDetails"
                    ? "active sectionLink policyDetails"
                    : "sectionLink policyDetails"
                }
                onClick={() => {
                  scrollToSection(policyDetails);
                  SetSectionStatus("policyDetails");
                }}
              >
                <span> Policy Details</span>
              </Link>

              <Link
                className={
                  sectionStatus === "insurerDetails"
                    ? "active sectionLink insurerDetails"
                    : "sectionLink insurerDetails"
                }
                onClick={() => {
                  scrollToSection(insurerDetails);
                  SetSectionStatus("insurerDetails");
                }}
              >
                <span>Insurer Details</span>
              </Link>
              <Link
                className={
                  sectionStatus === "organizationDetails"
                    ? "active sectionLink organizationDetails"
                    : "sectionLink organizationDetails"
                }
                onClick={() => {
                  scrollToSection(organizationDetails);
                  SetSectionStatus("organizationDetails");
                }}
              >
                <span>Organization Details</span>
              </Link>
              <Link
                className={
                  sectionStatus === "servicingDetails"
                    ? "active sectionLink servicingDetails"
                    : "sectionLink servicingDetails"
                }
                onClick={() => {
                  scrollToSection(servicingDetails);
                  SetSectionStatus("servicingDetails");
                }}
              >
                <span>Servicing Details</span>
              </Link>

              <Link
                className={
                  sectionStatus === "attatchmentsdetails"
                    ? "active sectionLink attatchmentsdetails"
                    : "sectionLink attatchmentsdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(attatchmentsdetails);
                  SetSectionStatus("attatchmentsdetails");
                }}
              >
                <span>Attatchments</span>
              </Link>
              <Link
                className={
                  sectionStatus === "emaildetails"
                    ? "active sectionLink emaildetails"
                    : "sectionLink emaildetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(emaildetails);
                  SetSectionStatus("emaildetails");
                }}
              >
                <span>Email</span>
              </Link>
              <Link
                className={
                  sectionStatus === "taskdetails"
                    ? "active sectionLink taskdetails"
                    : "sectionLink taskdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(taskdetails);
                  SetSectionStatus("taskdetails");
                }}
              >
                <span>Task</span>
              </Link>
            </Grid>
            <Grid xs className="rightSection h-100">
              <Grid container spacing={3} alignItems="center">
                <Grid xl={7} lg={8} md={10} xs={12} className="pl-0">
                  <div className="productTabs ">
                    <Button
                      className={
                        viewTabsStatus == "overview"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "overview");
                      }}
                    >
                      Overview
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "History"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "History");
                      }}
                    >
                      Policy History
                    </Button>

                    <Button
                      className={
                        viewTabsStatus == "Configuration"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "Configuration");
                      }}
                    >
                      Configuration
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "Features"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "Features");
                      }}
                    >
                      Features & Exclusions
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "Voluntaryplans"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "Voluntaryplans");
                      }}
                    >
                      Voluntary Plans
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "CDLedger"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "CDLedger");
                      }}
                    >
                      CD Ledger
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "Logs"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "Logs");
                      }}
                    >
                      Logs
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "notes"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "notes");
                      }}
                    >
                      Notes
                    </Button>
                  </div>
                </Grid>
                <Grid
                  xl={5}
                  lg={4}
                  md={2}
                  xs={12}
                  style={{ textAlign: "right" }}
                  className="text-sm-center"
                >
                  <p className="lastupdate">
                    Last Update: 11:00AM, 10th Nov, 2022
                  </p>
                </Grid>
              </Grid>
              {viewTabsStatus == "overview" ? (
                <>
                  <Grid container spacing={3}>
                    <Grid xs={9} className="pl-0">
                      <div className="client_info_section">
                        <p className="client_info_p freshPolicy md_width">
                          Fresh Policy
                        </p>
                        <p className="client_info_p empID md_width">
                          Employees : <span>50</span>
                        </p>
                        <p className="client_info_p dependents md_width">
                          Dependents: <span>50</span>
                        </p>
                        <p className="client_info_p totalEmployees md_width mr-0">
                          Lives: <span>100</span>
                        </p>
                      </div>
                    </Grid>
                    <Grid xs={3} className="align-self-center text-right">
                      <Link className="networkhosplist">
                        Network Hospital List
                      </Link>
                    </Grid>
                  </Grid>
                  <Box className="detailSection" ref={policyDetails}>
                    <div className="sectionTitle">
                      <h4>Policy Details</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid md={5} lg={4} xl={3}>
                        <div className="planname">
                          <p>
                            <span className="group_health"></span>Group Health
                            Insurance
                          </p>
                        </div>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid xs={6}>
                        <RKTextFieldDisable
                          class_name="inputField"
                          title="Premium"
                          value={premium}
                          attrName={setPremium}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={6}>
                        <RKTextFieldDisable
                          class_name="inputField"
                          title="CD Balance"
                          value={cDBalance}
                          attrName={setCDBalance}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={12}>
                        <p className="net_premium">
                          Net Premium - ₹ 8,20,000 | Tax @ 18 % - ₹ 1,80,000
                        </p>
                      </Grid>
                      <Grid xs={6}>
                        <DatePickerDisable
                          class_name="inputField"
                          title="Policy Start Date"
                          value={startDate}
                          attrName={setStartDate}
                          value_update={updateMasterState}
                          error_message="Please enter Start Date"
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={6}>
                        <DatePickerDisable
                          class_name="inputField"
                          title="Policy End Date"
                          value={endDate}
                          attrName={setEndDate}
                          value_update={updateMasterState}
                          error_message="Please enter End Date"
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="detailSection" ref={insurerDetails}>
                    <div className="sectionTitle">
                      <h4>Insurer Details</h4>
                    </div>
                    <Grid container spacing={3} alignItems="center">
                      <Grid
                        sm={4}
                        md={4}
                        lg={3}
                        xl={2}
                        className="text-center p-0"
                      >
                        {insurerName === "Sbi" ? (
                          <img
                            src="./images/insurerlogo/sbi_general_insurance.svg"
                            alt=""
                            className="insurer_logo"
                          />
                        ) : null}
                        {insurerName === "Religare" ? (
                          <img
                            src="./images/insurerlogo/Religare-Health-Insurance-Company-Limited.svg"
                            alt=""
                            className="insurer_logo"
                          />
                        ) : null}
                        {insurerName === "digit" ? (
                          <img
                            src="./images/insurerlogo/digit.svg"
                            alt=""
                            className="insurer_logo"
                          />
                        ) : null}
                        {insurerName === "reliance" ? (
                          <img
                            src="./images/insurerlogo/Reliance-General-Insurance-Co-Ltd.svg"
                            alt=""
                            className="insurer_logo"
                          />
                        ) : null}
                        {insurerName === "MaxBupa" ? (
                          <img
                            src="./images/insurerlogo/Max-Bupa-Health-Insurance-Company-Ltd.svg"
                            alt=""
                            className="insurer_logo"
                          />
                        ) : null}
                      </Grid>
                      <Grid sm={4} md={4} lg={4} xl={4}>
                        <SelectDropdownDisable
                          class_name="inputField"
                          title="Insurer Company Name"
                          value={insurerName}
                          attrName={setInsurerName}
                          value_update={updateMasterState}
                          dropdown_data={insurername_data}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={4} xl={4}>
                        <SearchDropdownDisable
                          class_name="inputField"
                          title="Office Address"
                          value={officeAddress}
                          attrName={setOfficeAddress}
                          value_update={updateMasterState}
                          data={officeAddress_data}
                          warn_status={false}
                          error_message="Please select office address"
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid
                        xs={12}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h5 className="subHeading">Single Person of Contact</h5>
                        <div className="sectionTitle spoc_section_title">
                          <div className="actionBtns">
                            <Link
                              className="blueBtn addfile"
                              onClick={() => {
                                setOpenContactForm(true);
                              }}
                              sx={{
                                textDecoration: "none",
                                cursor: "pointer",
                              }}
                            >
                              Add Contact
                            </Link>

                            <Link
                              className="redBtn delete"
                              onClick={() => {
                                setRemoveCategory(true);
                              }}
                              sx={{
                                textDecoration: "none",
                                cursor: "pointer",
                              }}
                            >
                              Delete
                            </Link>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                    <Box>
                      <SpocTable />
                    </Box>
                  </Box>
                  <Box className="detailSection" ref={organizationDetails}>
                    <div className="sectionTitle">
                      <h4>Organization Details</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid
                        sm={12}
                        style={{ display: "flex", flexWrap: "wrap" }}
                      >
                        <div className="client_organization">
                          <h6>
                            Organization Name <span>Evervent</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Client ID <span>CLT23456789</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Parent Client ID<span>CLT789056</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Parent Organization<span>Evervent Pvt Ltd</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Client Location<span>Karnal</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Email<span>everevent@domain.com</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Contact No.<span>9876543210</span>
                          </h6>
                        </div>
                      </Grid>
                      <Grid sm={6}>
                        <MultipleSearchDropdown
                          class_name="inputField"
                          title="Locations"
                          value={locations}
                          attrName={setLocations}
                          value_update={updateMasterState}
                          multiple_data={locations_data}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="detailSection" ref={servicingDetails}>
                    <div className="sectionTitle">
                      <h4>Servicing Details</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid xs={3}>
                        <SearchDropdownDisable
                          class_name="inputField"
                          title="Relationship Manager"
                          value={relationManager}
                          attrName={setRelationManager}
                          value_update={updateMasterState}
                          data={relationmanager_data}
                          warn_status={false}
                          error_message="Please select client"
                        />
                      </Grid>
                      <Grid xs={3}>
                        <SearchDropdownDisable
                          class_name="inputField"
                          title="Sales Person"
                          value={salesPerson}
                          attrName={setSalesPerson}
                          value_update={updateMasterState}
                          data={salesperson_data}
                          warn_status={false}
                          error_message="Please select client"
                        />
                      </Grid>
                      <Grid xs={3}>
                        <SearchDropdownDisable
                          class_name="inputField"
                          title="Servicing Partner"
                          value={servicingPartner}
                          attrName={setServicingPartner}
                          value_update={updateMasterState}
                          data={servecingpartner_data}
                          warn_status={false}
                          error_message="Please select client"
                        />
                      </Grid>
                      <Grid xs={3}>
                        <SelectDropdownDisable
                          class_name="inputField"
                          title="TPA"
                          value={tpa}
                          attrName={setTpa}
                          value_update={updateMasterState}
                          dropdown_data={tpa_data}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="detailSection" ref={attatchmentsdetails}>
                    <div className="sectionTitle">
                      <h4>Attatchments</h4>
                      <div className="actionBtns">
                        {/* <Link
                          className="redBtn delete"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link> */}

                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setUploadFile(true)}
                        >
                          Add New
                        </Link>
                      </div>
                    </div>
                    <Attachment
                      open_status={attachment}
                      attrName={setAttachment}
                      value_update={updateMasterState}
                    />
                  </Box>
                  <Box className="detailSection" ref={emaildetails}>
                    <div className="sectionTitle">
                      <h4>Emails </h4>
                      <div className="actionBtns">
                        <Link
                          className="redBtn delete"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link>

                        <Link
                          className="blueBtn edit"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Compose
                        </Link>
                      </div>
                    </div>

                    {/* Attachment Section Start*/}

                    <EmailComponent
                      open_status={emailcomp}
                      attrName={setEmailComp}
                      value_update={updateMasterState}
                    />
                    {/* Attachment Section End*/}
                  </Box>
                  {/* Task Section */}
                  <Grid container spacing={3} className="px-0">
                    <Grid xs={12}>
                      <Box className="detailSection mb-0" ref={taskdetails}>
                        <div className="sectionTitle">
                          <h4>Tasks </h4>
                          <div className="actionBtns">
                            <Link
                              className="blueBtn addfile"
                              sx={{
                                textDecoration: "none",
                                cursor: "pointer",
                              }}
                            >
                              Add Task
                            </Link>
                          </div>
                        </div>
                        <div className="mx-3">
                          <TasksSection />
                        </div>
                      </Box>
                    </Grid>
                  </Grid>
                </>
              ) : null}
              {viewTabsStatus == "Configuration" ? (
                <>
                  <PolicyConfig />
                </>
              ) : null}
              {viewTabsStatus == "History" ? (
                <>
                  <DetailPolicyHistory />
                </>
              ) : null}
              {viewTabsStatus == "Features" ? (
                <Box className="voluntry_plans_outer">
                  {planType === 0 ? (
                    <>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <ul className="coverageAmt">
                            <li>
                              <div className="radioBox ">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => setGradedSectionDta(0)}
                                  defaultChecked
                                />
                                <label>Grade 1</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => setGradedSectionDta(1)}
                                />
                                <label>Grade 2</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => setGradedSectionDta(2)}
                                />
                                <label>Grade 3</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => setGradedSectionDta(3)}
                                />
                                <label>Grade 4</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => setGradedSectionDta(4)}
                                />
                                <label>Grade 5</label>
                              </div>
                            </li>
                          </ul>
                        </Grid>
                      </Grid>
                    </>
                  ) : null}
                  {gradedSectionData === 0 ? (
                    <>
                      <FeaturesAndExclusion />
                    </>
                  ) : null}
                  {gradedSectionData === 1 ? (
                    <>
                      <FeaturesAndExclusion />
                    </>
                  ) : null}
                  {gradedSectionData === 2 ? (
                    <>
                      <FeaturesAndExclusion />
                    </>
                  ) : null}
                  {gradedSectionData === 3 ? (
                    <>
                      <FeaturesAndExclusion />
                    </>
                  ) : null}
                  {gradedSectionData === 4 ? (
                    <>
                      <FeaturesAndExclusion />
                    </>
                  ) : null}
                </Box>
              ) : null}

              {viewTabsStatus == "Voluntaryplans" ? (
                <Box className="voluntry_plans_outer common_accordion">
                  {planType === 0 ? (
                    <>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <ul className="coverageAmt">
                            <li>
                              <div className="radioBox ">
                                <input
                                  type="radio"
                                  name="coverages"
                                  defaultChecked
                                  onClick={() => {
                                    setVoluntaryGradedSectionData(0);
                                  }}
                                />
                                <label>Grade 1</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => {
                                    setVoluntaryGradedSectionData(1);
                                  }}
                                />
                                <label>Grade 2</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => {
                                    setVoluntaryGradedSectionData(2);
                                  }}
                                />
                                <label>Grade 3</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => {
                                    setVoluntaryGradedSectionData(3);
                                  }}
                                />
                                <label>Grade 4</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => {
                                    setVoluntaryGradedSectionData(4);
                                  }}
                                />
                                <label>Grade 5</label>
                              </div>
                            </li>
                          </ul>
                        </Grid>
                      </Grid>
                    </>
                  ) : null}
                  {voluntaryGradedSectionData === 0 ||
                  voluntaryGradedSectionData === 1 ? (
                    <Grid
                      container
                      spacing={3}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid xs={12}>
                        <div>
                          <Accordion
                            className="Accordion_section"
                            expanded={expanded === "panel1"}
                            onChange={handleChange("panel1")}
                          >
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography className="title">
                                Group Personal Accident
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion className="Accordion_section">
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                            >
                              <Typography className="title">
                                Group Critical illness
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </Grid>
                    </Grid>
                  ) : null}
                  {voluntaryGradedSectionData === 2 ? (
                    <Grid
                      container
                      spacing={3}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid xs={12}>
                        <div>
                          <Accordion
                            className="Accordion_section"
                            expanded={expanded === "panel1"}
                            onChange={handleChange("panel1")}
                          >
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography className="title">
                                Group Personal Accident
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion className="Accordion_section">
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                            >
                              <Typography className="title">
                                Group Critical illness
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </Grid>
                    </Grid>
                  ) : null}
                  {voluntaryGradedSectionData === 3 ? (
                    <Grid
                      container
                      spacing={3}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid xs={12}>
                        <div>
                          <Accordion
                            className="Accordion_section"
                            expanded={expanded === "panel1"}
                            onChange={handleChange("panel1")}
                          >
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography className="title">
                                Group Personal Accident
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion className="Accordion_section">
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                            >
                              <Typography className="title">
                                Group Critical illness
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </Grid>
                    </Grid>
                  ) : null}
                  {voluntaryGradedSectionData === 4 ? (
                    <Grid
                      container
                      spacing={3}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid xs={12}>
                        <div>
                          <Accordion
                            className="Accordion_section"
                            expanded={expanded === "panel1"}
                            onChange={handleChange("panel1")}
                          >
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography className="title">
                                Group Personal Accident
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion className="Accordion_section">
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                            >
                              <Typography className="title">
                                Group Critical illness
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </Grid>
                    </Grid>
                  ) : null}
                </Box>
              ) : null}

              {viewTabsStatus == "CDLedger" ? (
                <>
                  <CDLedger />
                </>
              ) : null}
              {viewTabsStatus == "Logs" ? (
                <>
                  <LogsTable />
                </>
              ) : null}
              {viewTabsStatus == "notes" ? (
                <Box className="detailSection">
                  <div className="sectionTitle">
                    <h4>Notes</h4>

                    <div className="actionBtns">
                      <Link
                        className="blueBtn addfile"
                        sx={{ textDecoration: "none", cursor: "pointer" }}
                        onClick={() => {
                          setPostQueryForm(true);
                        }}
                      >
                        Add Notes
                      </Link>
                    </div>
                  </div>

                  <NotesSection data={notesData} />
                </Box>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <SlidingPanel
        type={"right"}
        isOpen={openContactForm}
        size={75}
        backdropClicked={() => {
          setOpenContactForm(false);
        }}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={12}>
              <h4 className="mb-0 mt-4 ml-0">SPOC Details</h4>
            </Grid>
            <Grid xs={12} className="mb-4">
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            <Grid container spacing={3} className="mt-3">
              <Grid xs={7}>
                <SelectDropdown
                  class_name="inputField"
                  title="Select Contact"
                  value={spocContact}
                  attrName={setSpocContact}
                  value_update={updateMasterState}
                  dropdown_data={spoc_contact_data}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={5} className="mt-2" style={{ textAlign: "right" }}>
                <Link
                  className="greenBtn addfile"
                  underline="none"
                  onClick={() => {
                    navigate("/AddNewContact");
                  }}
                >
                  Create New Contact
                </Link>
              </Grid>
              {spocContact === "EV0065VikasSaini" ||
              spocContact === "EV0016KartikeKakkar" ? (
                <>
                  <Grid xs={6}>
                    <RKTextFieldDisable
                      class_name="inputField"
                      title="Name"
                      value={contactName}
                      attrName={setContactName}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Organization"
                      value={contactOrganization}
                      attrName={setContactOrganization}
                      value_update={updateMasterState}
                      dropdown_data={contact_organization_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Department"
                      value={contactDepartment}
                      attrName={setContactDepartment}
                      value_update={updateMasterState}
                      dropdown_data={contact_department_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Current Job Title"
                      value={jobTitle}
                      attrName={setJobTitle}
                      value_update={updateMasterState}
                      dropdown_data={job_title_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Current Employer"
                      value={currentEmployer}
                      attrName={setCurrentEmployer}
                      value_update={updateMasterState}
                      dropdown_data={current_employer_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextFieldDisable
                      class_name="inputField"
                      title="Email"
                      value={contactEmail}
                      attrName={setContactEmail}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextFieldDisable
                      class_name="inputField"
                      title="Mobile"
                      value={contactMobile}
                      attrName={setContactMobile}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextFieldDisable
                      class_name="inputField"
                      title="Contact number"
                      value={contactNumber}
                      attrName={setContactNumber}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                </>
              ) : null}
            </Grid>
          </div>
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {}}
              >
                Add SPOC
              </Button>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>
      <RemovePopup
        open_status={removeCategory}
        attrName={setRemoveCategory}
        value_update={updateMasterState}
      />
      <PostQueryForm
        attrName={setPostQueryForm}
        open_status={postQueryForm}
        value_update={updateMasterState}
      />
    </Box>
  );
}

export default PolicyDetailView;
